module.exports = __webpack_public_path__ + "static/epc_hero-248f1403a6d59e12bbd803aff42c805e.png";